import React from "react";
import styles from "../../../styles/about/components/AboutHero.module.css";
import heroImg from "../../../assets/images/image12.png";
import { Sparkles, Users, HeartHandshake, Book, Zap, Users2, Mic2 } from "lucide-react";
import EventNotificationPopup from "../../../components/EventNotificationPopup";

export default function AboutHero() {
  return (
    <>
      {/* Event Notification Popup */}
      <EventNotificationPopup />

      <section className={styles.heroSection}>
        <img src={heroImg} alt="CWFM Church" className={styles.heroImg} />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <div className={styles.heroContentInner}>
            <span className={styles.heroBadge}>
              We are grateful to see that you want to know about
            </span>

            <h1 className={styles.heroTitle}>
              Calvary Wide Fellowship Ministries
            </h1>

            <p className={styles.heroDesc}>
              Learn about our calling, our passion for the Gospel, and the
              community God is shaping through CWFM — a ministry rooted in the
              Word and led by the Holy Spirit.
            </p>
          </div>
        </div>
      </section>

      {/* Feature Cards Section */}
      <div className={styles.heroFeatures}>
        {/* Mission */}
        <div className={styles.featureCard}>
          <div className={styles.featureHeader}>
            <Sparkles className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Our Mission</h3>
          </div>

          <div className={styles.featureDesc}>
            <ul>
              <li>Promote the spirit of revival through repentance, fasting, and prayer</li>
              <li>Preach the transformative Word of God and raise an army of intercessors who contend for the manifestation of God's Kingdom on Earth</li>
              <li>Foster spiritual, social, and economic transformation</li>
            </ul>
          </div>
        </div>

        {/* Vision */}
        <div className={styles.featureCard}>
          <div className={styles.featureHeader}>
            <Users className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Our Vision</h3>
          </div>

          <p className={styles.featureDesc}>
            Life in its fullness — God, People, and Resources — by imitating Jesus Christ.
          </p>

          {/* Enhanced Verse Styling */}
          <div className={styles.verseRef}>
            "Imitate me, just as I also imitate Christ."
            <span>1 Corinthians 11:1</span>
          </div>
        </div>

        {/* Identity - Enhanced */}
        <div className={styles.featureCard}>
          <div className={styles.featureHeader}>
            <HeartHandshake className={styles.featureIcon} />
            <h3 className={styles.featureTitle}>Who We Are</h3>
          </div>

          <div className={styles.identityContent}>
            <p className={styles.identityIntro}>
              A Word-of-God oriented and Holy Spirit-led ministry committed to:
            </p>

            <div className={styles.identityPillars}>
              <div className={styles.pillarItem}>
                <Book className={styles.pillarIcon} />
                <span className={styles.pillarText}>Worship</span>
              </div>
              <div className={styles.pillarItem}>
                <Zap className={styles.pillarIcon} />
                <span className={styles.pillarText}>Intercession</span>
              </div>
              <div className={styles.pillarItem}>
                <Users2 className={styles.pillarIcon} />
                <span className={styles.pillarText}>Discipleship</span>
              </div>
              <div className={styles.pillarItem}>
                <Mic2 className={styles.pillarIcon} />
                <span className={styles.pillarText}>Spreading the Gospel</span>
              </div>
            </div>

            <div className={styles.identityOutcome}>
              <h4 className={styles.outcomeTitle}>Bringing Christ's Transformation</h4>
              <div className={styles.outcomeList}>
                <span className={styles.outcomeItem}>Hope</span>
                <span className={styles.outcomeItem}>Healing</span>
                <span className={styles.outcomeItem}>Restoration</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}